import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { AppSettings } from '../shared/AppSettings';

@Injectable()
export class CustomerService {

  readonly rootUrl = AppSettings.webApiURL;

  constructor(public httpClient: HttpClient) { }

  getAccountManagersDDL() {
    return this.httpClient.get(`${this.rootUrl}/api/FeedbackStatusFollowUpAPI/GetAccountManagersDDL`);
  }

  getCustomers() {
    return this.httpClient.get(`${this.rootUrl}/api/CustomerRefresh/CustomersList`);
  }

  deactivate(IdentityNumber: any) {
    return this.httpClient.get(`${this.rootUrl}/api/CustomerRefresh/Deactivate?IdentityNumber=${IdentityNumber}`);
  }

  SetAllowSecondReminder(IdentityNumber: any, allow: any) {
    return this.httpClient.get(`${this.rootUrl}/api/CustomerRefresh/SetAllowSecondReminder?IdentityNumber=${IdentityNumber}&allow=${allow}`);
  }

  SetAllowFirstReminder(IdentityNumber: any, allow: any) {
    return this.httpClient.get(`${this.rootUrl}/api/CustomerRefresh/SetAllowFirstReminder?IdentityNumber=${IdentityNumber}&allow=${allow}`);
  }

  setAllowLossWorkCapacityReminder(IdentityNumber: any, allow: any) {
    return this.httpClient.get(`${this.rootUrl}/api/CustomerRefresh/setAllowLossWorkCapacityReminder?IdentityNumber=${IdentityNumber}&allow=${allow}`);
  }

  getCustomerReminderList() {
    return this.httpClient.get(`${this.rootUrl}/api/CustomerRefresh/CustomerReminderList`);
  }

  saveCustomerAccountManager(customerIdentityNumber: any, managerName: any, managerEMail: any) {
    return this.httpClient.get(`${this.rootUrl}/api/CustomerRefresh/CustomerAccountManagerUpdate?customerIdentityNumber=${customerIdentityNumber}&managerName=${managerName}&managerEMail=${managerEMail}`);
  }

  getCustomersNotReported(accountManager) {
    return this.httpClient.get(`${this.rootUrl}/api/CustomerRefresh/GetCustomersNotReported?accountManager=${accountManager == null ? '' : accountManager}`);
  }

  sendReminders(type) {
    return this.httpClient.get(`${this.rootUrl}/api/CustomerRefresh/SendReminders?type=${type}`);
  }

  public getCustomerLossWorkCapacityList(accountManagers, customers, month) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    let filter = {AccountManager: accountManagers, Customers: customers, BuildMonth: month}
    return this.httpClient.post(`${this.rootUrl}/api/CustomerLossWorkCapacity/getCustomerLossWorkCapacityList`, filter, { headers });
  }
  
  // sendLossWorkCapacityReminders(type) {
  //   return this.httpClient.get(`${this.rootUrl}/api/CustomerLossWorkCapacity/SendLossWorkCapacityReminders`);
  // }



}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/service/customer.service.ts